import {useEffect, useState} from "react";

import {COUNTERTOP_GROUP} from "../../kvComponent/core/constants";
import {getFilterGroupValues} from "../../../misc/utils";
import {getBvGroupFilterValues} from "../../../api/server-api";
import {setActivePartFilterValues} from "../../../misc/filtersFunctions";

/**
 *
 * @param currentParent {object}
 * @param currentFeatures {array}
 * @param filterGroups {array}
 * @param fabricatorData {object}
 * @returns {object}
 */
export const getWithFilters = (currentParent, currentFeatures, filterGroups, fabricatorData) => {

  if (!currentParent) {
    return {withFilters: false, filtersLoading: false}
  }

  let withFilters = false;
  const materialFilterGroup = filterGroups.find(filterGroup => filterGroup.name.trim() === "Countertop Material");

  const caesProfiles = fabricatorData.isCaesarStone && (
    (fabricatorData.fabricatorName && fabricatorData.fabricatorName.includes("QC Master Account US"))
    || (fabricatorData.fabricatorName && fabricatorData.fabricatorName.includes("QC Master Account CAN"))
    || (fabricatorData.fabricatorName && fabricatorData.fabricatorName === "Caesarstone new versions NEW")
    || (fabricatorData.wasCreatedFromFabricator && fabricatorData.wasCreatedFromFabricator.includes("QC Master Account US"))
    || (fabricatorData.wasCreatedFromFabricator && fabricatorData.wasCreatedFromFabricator.includes("QC Master Account CAN"))
    || (fabricatorData.wasCreatedFromFabricator && fabricatorData.wasCreatedFromFabricator === "Caesarstone new versions NEW")
  );

  if ((fabricatorData.isLowes || caesProfiles)
    && COUNTERTOP_GROUP.includes(currentParent.partId) && materialFilterGroup && materialFilterGroup.values) {
    if (!currentParent.filtersReceived) {
      return {withFilters, filtersLoading: true}
    } else if (materialFilterGroup.values.some(filterValue => currentParent.filtersReceived.includes(filterValue.id))) {
      const filterValuesAvailable = materialFilterGroup.values.filter(filterValue => {
        return currentParent.filtersReceived.includes(filterValue.id)
      })
      // console.log("filterValuesAvailable", filterValuesAvailable);
      withFilters = filterValuesAvailable.some((filterValue) => {
        const countertopsFiltered = currentFeatures.filter(feature => {
          if (!feature || !feature.part) { // just in case
            return false
          }
          const countertopFilters = getFilterGroupValues(feature.part, materialFilterGroup);
          return countertopFilters && countertopFilters.includes(filterValue.id)
        });
        return countertopsFiltered.length
      })
    }
  }
  return {withFilters, filtersLoading: false}
}

export const useGetFiltersRequest = (useRequest, requestFilters, featureGroup, allFilterGroups) => {

  const [filtersLoaded, setFiltersLoaded] = useState(!requestFilters);

  const checkFilters = async () => {
    const featureGroupFiltersResponse = await getBvGroupFilterValues(featureGroup.dbName || featureGroup.partName, null, false);
    setActivePartFilterValues(featureGroupFiltersResponse.data, featureGroup, allFilterGroups);
    setFiltersLoaded(true)
  }

  useEffect(() => {
    if (useRequest && requestFilters) {
      checkFilters();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [requestFilters, featureGroup])

  return filtersLoaded
}
